import React from 'react';
import { ShieldCheckIcon, ArrowRightIcon, AwardIcon } from 'lucide-react';
export function EducationSection() {
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#1e3d2f'
  }} aria-label="Education and Safety" data-id="element-1649">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-1650">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center" data-id="element-1651">
          <div className="flex-1" data-id="element-1652">
            <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1653">
              Safety First
            </p>
            <h2 className="text-3xl md:text-4xl font-bold uppercase mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-1654">
              Education &amp; Safety
            </h2>
            <div className="section-divider" data-id="element-1655" />
            <p className="text-base leading-relaxed mb-6" style={{
            color: '#c8d8cc',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1656">
              FLSC offers comprehensive firearms training to both members and
              non-members throughout the year. All classes are led by NRA
              Certified Instructors and overseen by NRA Certified Range Safety
              Officers. Members receive discounted pricing on all classes.
            </p>

            <div className="space-y-3 mb-8" data-id="element-1657">
              {['First Steps Rifle, Shotgun &amp; Pistol', 'New Gun Owner Orientation Classes', 'Concealed Pistol License (CPL) Training', 'NRA Certified Instructor Pathways', 'Personal Protection In &amp; Outside The Home', 'Civilian Response to Active Shooter Events (CRASE)'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-1658">
                  <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                backgroundColor: 'rgba(200,168,75,0.2)',
                border: '1px solid rgba(200,168,75,0.4)'
              }} data-id="element-1659">
                    <div className="w-1.5 h-1.5 rounded-full" style={{
                  backgroundColor: '#c8a84b'
                }} data-id="element-1660" />
                  </div>
                  <p className="text-sm" style={{
                color: '#c8d8cc',
                fontFamily: 'Inter, sans-serif'
              }} dangerouslySetInnerHTML={{
                __html: item
              }} data-id="element-1661" />
                </div>)}
            </div>

            <div className="flex flex-wrap gap-3" data-id="element-1662">
              <a href="/Calendar.html" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
              backgroundColor: '#c8a84b',
              color: '#1a1a1a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1663">
                View Class Schedule
                <ArrowRightIcon size={15} data-id="element-1664" />
              </a>
              <a href="/FLSCSelfDefense.html" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-medium text-sm border transition-all hover:bg-white/10" style={{
              borderColor: 'rgba(255,255,255,0.25)',
              color: '#e8e4d8',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1665">
                All Classes
              </a>
            </div>
          </div>

          <div className="w-full lg:w-80 flex-shrink-0 grid grid-cols-2 gap-4" data-id="element-1666">
            <div className="col-span-2 rounded-2xl p-6 text-center" style={{
            backgroundColor: 'rgba(200,168,75,0.12)',
            border: '1px solid rgba(200,168,75,0.25)'
          }} data-id="element-1667">
              <AwardIcon size={32} className="mx-auto mb-3" style={{
              color: '#c8a84b'
            }} data-id="element-1668" />
              <p className="text-2xl font-bold uppercase mb-1" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#ffffff'
            }} data-id="element-1669">
                NRA Certified
              </p>
              <p className="text-sm" style={{
              color: '#a0b8a8',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1670">
                All instructors are NRA Certified. Range Safety Officers
                on-site.
              </p>
            </div>

            <div className="rounded-2xl p-5 text-center" style={{
            backgroundColor: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)'
          }} data-id="element-1671">
              <ShieldCheckIcon size={24} className="mx-auto mb-2" style={{
              color: '#c8a84b'
            }} data-id="element-1672" />
              <p className="text-sm font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#ffffff'
            }} data-id="element-1673">
                Members &amp; Public
              </p>
              <p className="text-xs mt-1" style={{
              color: '#7a9a8a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1674">
                Open to all
              </p>
            </div>

            <div className="rounded-2xl p-5 text-center" style={{
            backgroundColor: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)'
          }} data-id="element-1675">
              <ShieldCheckIcon size={24} className="mx-auto mb-2" style={{
              color: '#c8a84b'
            }} data-id="element-1676" />
              <p className="text-sm font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#ffffff'
            }} data-id="element-1677">
                Member Discount
              </p>
              <p className="text-xs mt-1" style={{
              color: '#7a9a8a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1678">
                On all classes
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}